module.exports = __webpack_public_path__ + "img/cleaning.d5e070a0.svg";